<!-- Details.vue -->
<template>
	<div class="show-iframe">
  <div class="mb-body" v-if="detailInfo.plateid_top && detailInfo.plate_top" v-html="detailInfo.plate_top.storeplate_content">

			</div>
		<div v-if="!mbBody.length">
			<div class="mb-body" v-if="detailInfo.goods_body">
				<div v-html="detailInfo.goods_body"></div>
			</div>
			<div class="list-empty" v-else>
				<p>本商品暂无详情</p>
			</div>
		</div>
		<div class="mb-body" v-else>
			<div v-for="(item,index) in mbBody" :key="index">
				<p v-if="item.type=='text'">{{item.value}}</p>
				<img v-else :src="item.value">
			</div>
		</div>
    <div class="mb-body" v-if="detailInfo.plateid_bottom && detailInfo.plate_bottom" v-html="detailInfo.plate_bottom.storeplate_content">

			</div>
	</div>
</template>

<script>

export default {
  data () {
    return {}
  },
  computed: {
    getUrl: function () {
      return this.url
    }
  },
  props: ['mbBody', 'detailInfo'],
  methods: {}
}
</script>

<style lang="scss">
.show-iframe {
	height: 100%;
}

.list-empty {
  padding:1rem 0;
	text-align: center;
	p {
		color: #7c7f88;
		font-size: 0.7rem;
		padding: 0;
		margin: 0;
		font-weight: normal;
	}
}
.mb-body {font-size:.7rem;
	img{max-width:100%}
}
</style>
